<template>
    <div class="bottom-0 inset-x-0 px-4 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-20">
        <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed inset-0 transition-opacity" v-if="show">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
        </transition>

        <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
            <div class="bg-leonard-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-if="show">
                <div>
                    <div class="mx-auto w-10 h-10 place-content-center text-center rounded-md bg-leonard-info-overlay">
                        <font-awesome-icon fixed-width :icon="['fas', 'bullhorn']" class="text-leonard-white" />
                    </div>
                    <div class="mt-3 text-center sm:mt-5">
                        <h3 class="text-gray-900" id="modal-headline">{{header}}</h3>
                        <p class="my-2">{{body}}</p>
                    </div>
                </div>
                <div class="mt-5 sm:mt-6">
                    <button type="button" class="font-medium transition-all duration-300 border-2 rounded-md block w-full py-2 px-3 md:px-4 bg-leonard-info border-leonard-info text-leonard-white hover:bg-leonard-info-overlay hover:border-transparent focus:ring-leonard-info-overlay cursor-pointer" @click.prevent="close">
                        Close
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faBullhorn} from '@fortawesome/free-solid-svg-icons';

export default {
    props: ['show', 'header', 'body'],

    methods: {
        created() {
            library.add(faBullhorn);
        },
        close() {
            this.$emit('toggleBannerModal', false);
        }
    }
}
</script>

<style scoped>

</style>
